/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Givefeedbackdescription_V22Inputs */

const en_settings_givefeedbackdescription_v22 = /** @type {(inputs: Settings_Givefeedbackdescription_V22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got ideas or suggestions? We would like to hear from you`)
};

/**
* | output |
* | --- |
* | "Got ideas or suggestions? We would like to hear from you" |
*
* @param {Settings_Givefeedbackdescription_V22Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_givefeedbackdescription_v22 = /** @type {((inputs?: Settings_Givefeedbackdescription_V22Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Givefeedbackdescription_V22Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_givefeedbackdescription_v22(inputs)
});
export { settings_givefeedbackdescription_v22 as "settings_giveFeedbackDescription_v2" }